var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-frown",
  "use": "ring-icon-frown-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-frown\"><path d=\"M8.043-.004a8 8 0 1 0 8 8 8 8 0 0 0-8-8zM3.283 7.31L5.67 4.922A1.93 1.93 0 1 1 3.283 7.31zm7.075 5.505a.5.5 0 0 1-.707 0 2.278 2.278 0 0 0-3.217 0 .5.5 0 0 1-.707-.707 3.279 3.279 0 0 1 4.631 0 .5.5 0 0 1 0 .707zm.595-4.108a1.93 1.93 0 0 1-.538-3.785l2.388 2.388a1.929 1.929 0 0 1-1.85 1.397z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id